export enum ZeitpunktZumAufrufen {
  VOR_AMOR = "VOR_AMOR",
  NACH_AMOR = "NACH_AMOR",
  VOR_WERWOLF = "VOR_WERWOLF",
  NACH_WERWOLF = "NACH_WERWOLF",
  VOR_HEXE = "VOR_HEXE",
  NACH_HEXE = "NACH_HEXE",
}
